<script>
/**
 * ****************************************************************************
 * @description     :   Main component for page APP_WorkReport002
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – namnth@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapActions, mapMutations, mapState } from 'vuex';
import store from '@/store';
// import APP_WorkReport002_store from '@/views/mobile/app_work_report/APP_WorkReport002/store';
import MngReportComment from '@/components/mngReportComment/index.vue';
import APP_SalesReport002 from '@/views/mobile/app_sales_report/APP_SalesReport002/index.vue';

/**
 * Import template
 */
import template from './template.html';
import './style.scss';
import messages, { MSG_BUTTON, MSG_TITLE, MSG_TYPE } from '@/utils/messages';
import MNG_WorkReport002_store from '@/views/move/mng_workreport/MNG_WorkReport002/store';
import PopupMST001 from '@/views/popupSearch/PopupMST001/store';
import PopupMST005 from '@/views/popupSearch/PopupMST005/store';
import PopupMST007 from '@/views/popupSearch/PopupMST007/store';
import PopupSystem001 from '@/views/popupSearch/PopupSystem001/store';
import MNG_SalesReport002 from '@/views/move/mng_salesreport/MNG_SalesReport002/index.vue';
import PopupMST002 from '@/views/popupSearch/PopupMST002/store';
import helpers from '@/utils/helpers';
/**
 * Define component chat for show page chat
 */
var APP_WorkReport002 = {
    template: template,
    components: { MNG_SalesReport002, MngReportComment, APP_SalesReport002 },
    props: {
        typeSelected: {
            type: Number,
            default: 1
        },
        companyCd: {
            type: [String, Number],
            default: ''
        },
        workReportId: {
            type: [String, Number],
            default: ''
        }
    },
    beforeCreate() {
        if (!store.hasModule('MNG_WorkReport002')) {
            store.registerModule('MNG_WorkReport002', MNG_WorkReport002_store);
        }
        if (!store.hasModule('PopupMST001')) {
            store.registerModule('PopupMST001', PopupMST001);
        }
        if (!store.hasModule('PopupMST002')) {
            store.registerModule('PopupMST002', PopupMST002);
        }
        if (!store.hasModule('PopupMST005')) {
            store.registerModule('PopupMST005', PopupMST005);
        }
        if (!store.hasModule('PopupMST007')) {
            store.registerModule('PopupMST007', PopupMST007);
        }
        if (!store.hasModule('PopupSystem001')) {
            store.registerModule('PopupSystem001', PopupSystem001);
        }
    },
    created() {
        this.setScreenId(this.screenId);
        this.thisYear = new Date().getFullYear().toString().slice(-2);
        this.isEnableSubmit = this.workReportValidation.pass;
        this.loadOptions();
        if (this.workReportId) {
            this.getData({
                params: {
                    company_cd: this.companyCd,
                    work_report_id: this.workReportId
                },
                callback: () => {
                    this.isReady = true;
                }
            });
        } else {
            this.initForm();
            this.isReady = true;
        }
    },
    mounted() {
        this.setHeader(this.header);
        this.validateWorkingDate();
    },
    unmounted() {},
    data() {
        return {
            screenId: 'APP_WorkReport002',
            activeIndex: 0,
            isShowReportComment: false,
            errors: [],
            thisYear: 0,
            isReady: false,
            isEnableSubmit: false
        };
    },
    emits: ['emitHideDetail'],
    watch: {
        companyWorkReport() {
            this.isReady = false;
            this.activeIndex = 0;
            this.errors = [];
            this.setHeader(this.header);
            this.isEnableSubmit = this.workReportValidation.pass;

            this.getData({
                params: {
                    company_cd: this.companyCd,
                    work_report_id: this.workReportId
                },
                callback: () => {
                    this.isReady = true;
                }
            });
        },
        canSubmit(val) {
            this.isEnableSubmit = val;
        },
        'data.general.CompanyCD': {
            handler(newVal, oldVal) {
                if (this.isEditMode) return;
                if (newVal === oldVal) return;

                if (oldVal === undefined) {
                    this.syncCompanyCD(newVal);
                    return;
                }

                this.clearCompanyDependentFields();
                this.syncCompanyCD(newVal);
            },
            immediate: true
        },

        'data.general.MDCD': {
            handler(newVal, oldVal) {
                if (this.isEditMode) return;
                if (newVal === oldVal) return;

                if (oldVal === undefined) {
                    this.syncMDCD(newVal);
                    return;
                }

                this.clearMDCDDependentFields();
                this.syncMDCD(newVal);
            },
            immediate: true
        }
    },
    computed: {
        ...mapState('app', ['user', 'isShowLeftMenu']),
        ...mapState('MNG_WorkReport002', ['optionGroup', 'data']),
        header() {
            const data = {
                title: '業務日報登録',
                topButtons: []
            };
            return data;
        },
        commentProps() {
            return {
                CompanyCD: this.data.general.CompanyCD,
                WorkReportID: this.data.general.WorkReportID,
                MDCD: this.data.general.MDCD,
                OfficeCD: this.data.general.OfficeCD,
                EmployeeCD: this.data.general.EmployeeCD
            };
        },
        isEditMode() {
            return !!this.data.general.WorkReportID;
        },
        placesLength() {
            return this.data.places.length;
        },
        companyWorkReport() {
            return this.companyCd + '_' + this.workReportId;
        },
        loginCompanyCd() {
            const companyCd = Number(this.user?.company_cd);
            return Number.isNaN(companyCd) ? null : companyCd;
        },
        isCompanyEditable() {
            return this.loginCompanyCd === null || this.loginCompanyCd === 99;
        },
        workReportValidation() {
            return this.checkWorkReportPass(this.data);
        },
        canSubmit() {
            return this.workReportValidation.pass;
        },
        validateError() {
            let message = '';
            if (this.errors) {
                this.errors.forEach((item) => {
                    if (item.name == this.id) {
                        message = item.message;
                    }
                });
            }
            return message;
        }
    },
    methods: {
        ...mapMutations('app', [
            'showHeaderError',
            'setScreenId',
            'setHeader',
            'setNotification',
            'showModalMessage',
            'hideModalMessage',
            'hideHeaderError'
        ]),
        ...mapActions('PopupMST001', ['searchMst001Info']),
        ...mapActions('PopupMST002', ['searchMst002Info']),
        ...mapActions('PopupMST005', ['searchAreaInfo']),
        ...mapActions('PopupMST007', ['searchOfficeInfo']),
        ...mapActions('PopupSystem001', ['searchSystemInfo']),
        ...mapMutations('MNG_WorkReport002', ['resetFormData', 'changeTypeState', 'setMeiShoCd']),
        ...mapActions('MNG_WorkReport002', ['getData', 'saveData', 'getOrderDetail']),
        clearFields(target, fields) {
            if (!target || typeof target !== 'object') return;

            fields.forEach((field) => {
                if (field in target) {
                    target[field] = '';
                }
            });
        },

        syncCompanyCD(companyCD) {
            this.data.time_schedule?.forEach((item) => {
                if ('CompanyCD' in item) item.CompanyCD = companyCD;
            });

            this.data.sites?.forEach((site) => {
                if ('CompanyCD' in site) site.CompanyCD = companyCD;

                site.client_staff?.forEach((staff) => {
                    if ('CompanyCD' in staff) staff.CompanyCD = companyCD;
                });
            });
        },

        clearCompanyDependentFields() {
            const fields = ['MDCD', 'MDName', 'OfficeCD', 'OfficeName', 'ClientCD', 'ClientName', 'BranchCD', 'BranchName'];

            this.clearFields(this.data.general, fields);

            this.data.time_schedule?.forEach((item) => {
                this.clearFields(item, fields);
            });

            this.data.sites?.forEach((site) => {
                this.clearFields(site, fields);
                site.client_staff?.forEach((staff) => this.clearFields(staff, fields));
            });
        },

        syncMDCD(mdcd) {
            this.data.sites?.forEach((site) => {
                if ('MDCD' in site) site.MDCD = mdcd;

                site.client_staff?.forEach((staff) => {
                    if ('MDCD' in staff) staff.MDCD = mdcd;
                });
            });
        },

        clearMDCDDependentFields() {
            const fields = ['OfficeCD', 'OfficeName', 'BranchCD', 'BranchName'];

            this.clearFields(this.data.general, fields);

            this.data.sites?.forEach((site) => {
                this.clearFields(site, fields);
                site.client_staff?.forEach((staff) => this.clearFields(staff, fields));
            });
        },
        async loadOptions() {
            try {
                const companyCd = this.data.general.CompanyCD || this.user?.company_cd || '';
                const result = await helpers.getDataSys005({ meisho_cd: '200', company_cd: companyCd });
                this.setMeiShoCd(result);
            } catch (e) {
                console.log('loadOptions: ' + e.message);
                this.jobOptions = [];
            }
        },
        checkWorkReportPass(data) {
            const general = data?.general || {};
            const sites = data?.sites || [];

            const isValidDate = (d) => {
                if (!d) return false;

                let str = d;
                if (str.length === 8 && !str.includes('/')) {
                    str = `${str.substring(0, 4)}/${str.substring(4, 6)}/${str.substring(6, 8)}`;
                }

                const date = new Date(str);
                return !isNaN(date.getTime());
            };

            const isWorkingDateTooOld = (d) => {
                if (!d) return false;

                let str = d;
                if (str.length === 8 && !str.includes('/')) {
                    str = `${str.substring(0, 4)}/${str.substring(4, 6)}/${str.substring(6, 8)}`;
                }

                const workingDate = new Date(str);
                if (isNaN(workingDate.getTime())) return false;

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const threeDaysAgo = new Date(today);
                threeDaysAgo.setDate(today.getDate() - 3);

                workingDate.setHours(0, 0, 0, 0);

                return workingDate <= threeDaysAgo;
            };

            const rules = [
                { invalid: !general.CompanyCD, name: 'CompanyCD' },
                {
                    invalid: !general.WorkDate || !isValidDate(general.WorkDate),
                    name: 'WorkDate'
                },
                {
                    invalid: isValidDate(general.WorkDate) && isWorkingDateTooOld(general.WorkDate),
                    name: 'WorkDateTooOld'
                },
                { invalid: this.isShowReportComment, name: 'showCommentReport' },
                { invalid: !general.MDCD, name: 'MDCD' },
                { invalid: !general.OfficeCD, name: 'OfficeCD' }
            ];

            sites.forEach((site) => {
                if (site.type == 3) {
                    const tabIndex = Number(site.id) - 1;

                    rules.push(
                        { invalid: !site.ClientCD, name: `ClientCD${site.id}`, tabIndex },
                        { invalid: !site.BranchCD, name: `BranchCD${site.id}`, tabIndex }
                    );

                    const clientStaff = site.client_staff || [];

                    clientStaff.forEach((staff, index) => {
                        rules.push(
                            {
                                invalid: !staff.StaffName,
                                name: `StaffName_${site.id}_${index}`,
                                tabIndex
                            },
                            {
                                invalid: !staff.StartDate || !isValidDate(staff.StartDate),
                                name: `StartDate_${site.id}_${index}`,
                                tabIndex
                            }
                        );
                    });
                }
            });

            const invalidRules = rules.filter((r) => r.invalid);

            return {
                pass: invalidRules.length === 0,
                invalidFields: invalidRules.map((r) => r.name),
                errorTabs: invalidRules.filter((r) => r.tabIndex !== undefined).map((r) => r.tabIndex)
            };
        },
        initForm() {
            this.activeIndex = 0;
            this.resetFormData();
            this.errors = [];
            this.errorTabs = [];
            this.data.general.CompanyCD = this.user?.company_cd ?? 0;
            this.data.general.MDCD = this.user?.MDCD ?? 0;
            this.data.general.OfficeCD = this.user?.OfficeCD ?? 0;
            this.data.general.EmployeeCD = this.user?.UserID ? String(this.user.UserID).padStart(8, '0') : 0;
            this.data.general.UserName = this.user?.UserName ?? 0;
            this.referCompanyInfo(0, this.data.general.CompanyCD);
            this.referMDCD(0, this.data.general.MDCD, true);
            this.referOffice(0, this.data.general.OfficeCD);
            this.data.sites.push(
                {
                    id: 1,
                    type: 1,
                    index_type: 1,
                    ORDNo: '',
                    ORDDetailNo: '',
                    OnSiteMTGGr1: [],
                    OnSiteMTGCHK3: 1,
                    OnSiteMTGGr2: [],
                    OnSiteClient: [],
                    ClientCD: '',
                    ClientName: '',
                    MDCD: this.data.general.MDCD,
                    BranchCD: '',
                    BranchName: '',
                    BillingName: '',
                    WorkTimeFrom: '',
                    WorkTimeTo: '',
                    HeadCount: '',
                    ArrangementPurpose: '',
                    ActionResult: '',
                    ProjectInformationFLG: '1',
                    ProjectInformationDetail: '',
                    SharedInformationFLG: '1',
                    SharedInformationDetail: '',
                    OtherInformationDetail: ''
                },
                {
                    id: 2,
                    type: 2,
                    index_type: 1,
                    ArrangementProgress: '',
                    ArrangementPurpose: ''
                },
                {
                    id: 3,
                    type: 3,
                    index_type: 1,
                    CompanyCD: this.data.general.CompanyCD,
                    MDCD: this.data.general.MDCD,
                    ClientCD: '',
                    ClientName: '',
                    VisitDate: '',
                    ReportDate: '',
                    SalesNoteCheck: [],
                    SalesNote: '',
                    client_staff: [
                        {
                            id: 3,
                            StartDate: '',
                            StaffName: '',
                            FilePath: '',
                            File: '',
                            Remarks: ''
                        }
                    ],
                    ReportDetail: '',
                    FilePath: '',
                    past_sales_records: [],
                    paginationData: { pageNo: 1, pageSize: 5, totalRows: 0, msgNoData: '該当するデータが存在しません。' }
                }
            );
        },
        changeORDNo(site) {
            site.ORDDetailNo = '';
            document.getElementById(site.ORDNo ? 'ORDDetailNo' : 'ORDNo').focus();
        },
        referOrderDetail(site) {
            if (!site.ORDNo) {
                document.getElementById('ORDNo').focus();
                return;
            }
            if (!site.ORDDetailNo) {
                document.getElementById('ORDDetailNo').focus();
                return;
            }
            this.getOrderDetail({
                params: {
                    company_cd: this.data.general.CompanyCD,
                    order_no: site.ORDNo,
                    order_no_detail: site.ORDDetailNo
                },
                callback: (data) => {
                    site.ClientCD = data.ClientCD;
                    site.ClientName = data.ClientName;
                    site.BranchCD = data.BranchCD;
                    site.BranchName = data.BranchName;
                    site.BillingName = data.BillingName;
                    site.WorkTimeFrom = data.WorkTimeFrom;
                    site.WorkTimeTo = data.WorkTimeTo;
                    site.HeadCount = data.Quantity;
                }
            });
        },
        addNewSchedule() {
            this.data.time_schedule.push({ WorkTime: '', WorkType: '1', WorkDetail: '' });
        },
        renderNo(index) {
            return index + 1 < 10 ? '0' + (index + 1) : index + 1;
        },
        typeHeaderAddNew() {
            if (this.data.sites.length > 14) {
                return;
            }
            // Đếm số lượng tab có cùng type với type_header
            let count = 0;
            this.data.sites.forEach((place) => {
                if (place.type == this.data.type_header) {
                    count++;
                }
            });
            // index_type của tab mới sẽ là số lượng hiện tại + 1
            let index_type = count + 1;
            let newTab = {
                id: this.data.sites.length + 1,
                type: this.data.type_header,
                index_type: index_type
            };
            switch (parseInt(this.data.type_header)) {
                case 1:
                    newTab = {
                        ...newTab,
                        ORDNo: '',
                        ORDDetailNo: '',
                        OnSiteMTGGr1: [],
                        OnSiteMTGCHK3: 1,
                        OnSiteMTGGr2: [],
                        OnSiteClient: [],
                        ClientCD: '',
                        ClientName: '',
                        MDCD: this.data.general.MDCD,
                        BranchCD: '',
                        BranchName: '',
                        BillingName: '',
                        WorkTimeFrom: '',
                        WorkTimeTo: '',
                        HeadCount: '',
                        ArrangementPurpose: '',
                        ActionResult: '',
                        ProjectInformationFLG: '1',
                        ProjectInformationDetail: '',
                        SharedInformationFLG: '1',
                        SharedInformationDetail: '',
                        OtherInformationDetail: ''
                    };
                    break;
                case 2:
                    newTab = {
                        ...newTab,
                        ArrangementProgress: '',
                        ArrangementPurpose: ''
                    };
                    break;
                case 3:
                    newTab = {
                        ...newTab,
                        CompanyCD: this.data.general.CompanyCD,
                        MDCD: this.data.general.MDCD,
                        ClientCD: '',
                        ClientName: '',
                        VisitDate: '',
                        ReportDate: '',
                        SalesNoteCheck: [],
                        SalesNote: '',
                        client_staff: [
                            {
                                id: this.data.sites.length + 1,
                                StartDate: '',
                                StaffName: '',
                                FilePath: '',
                                File: '',
                                Remarks: ''
                            }
                        ],
                        ReportDetail: '',
                        FilePath: '',
                        past_sales_records: [],
                        paginationData: { pageNo: 1, pageSize: 10, totalRows: 0, msgNoData: '該当するデータが存在しません。' }
                    };
            }

            this.data.sites.push(newTab);

            this.nextId++;
            this.$nextTick(() => {
                this.activeIndex = this.data.sites.length - 1;
            });
        },
        renderTabNumber(number) {
            const map = {
                1: '①',
                2: '②',
                3: '③',
                4: '④',
                5: '⑤',
                6: '⑥',
                7: '⑦',
                8: '⑧',
                9: '⑨',
                10: '⑩',
                11: '⑪',
                12: '⑫',
                13: '⑬',
                14: '⑭',
                15: '⑮'
            };
            return map[number];
        },
        hideDetail() {
            this.$emit('emitHideDetail');
        },
        openCommentReport() {
            this.isShowReportComment = true;
        },
        buildSalesClientStaffCautions(salesTabs = []) {
            const normalizeCode = (value) => {
                if (value === null || value === undefined || value === '') return '';
                const num = Number(value);
                return Number.isNaN(num) ? String(value).trim() : String(num);
            };

            const buildClientBranchKey = (clientCD, branchCD) => {
                return `${normalizeCode(clientCD)}__${normalizeCode(branchCD)}`;
            };

            const groups = salesTabs.reduce((map, tab, i) => {
                const clientCD = normalizeCode(tab?.ClientCD);
                const branchCD = normalizeCode(tab?.BranchCD);

                if (!clientCD || !branchCD) return map;

                const groupKey = buildClientBranchKey(clientCD, branchCD);

                if (!map.has(groupKey)) {
                    map.set(groupKey, {
                        clientCD,
                        branchCD,
                        indexes: []
                    });
                }

                map.get(groupKey).indexes.push(i);
                return map;
            }, new Map());

            const messages = [];
            const winnersByClientBranch = {};
            let hasDiff = false;

            for (const [groupKey, group] of groups) {
                const { clientCD, branchCD, indexes } = group;

                if (indexes.length < 2) continue;

                const winnerIndex = indexes[indexes.length - 1];
                const winnerTab = salesTabs[winnerIndex];
                const winnerSig = getSignature(winnerTab);

                const diff = indexes.slice(0, -1).some((i) => {
                    const tabSig = getSignature(salesTabs[i]);
                    return tabSig !== winnerSig;
                });

                winnersByClientBranch[groupKey] = {
                    ...winnerTab,
                    ClientCD: clientCD,
                    BranchCD: branchCD,
                    client_staff: (winnerTab?.client_staff ?? []).map((s) => ({ ...s }))
                };

                if (diff) {
                    hasDiff = true;
                    const clientName = winnerTab?.ClientName || winnerTab?.client_name || winnerTab?.BillingName || '';
                    const branchName = winnerTab?.BranchName || '';
                    const label = `営業${toCircled(winnerIndex + 1)}`;
                    messages.push(
                        `取引先名：${clientName}${
                            branchName ? `\u3000支店名：${branchName}` : ''
                        }\u3000の発注担当者に差異があります。\n登録時は「${label}」のデータが優先されます。`
                    );
                }
            }

            return { hasDiff, messages, winnersByClientBranch };

            function getSignature(tab) {
                const rows = Array.isArray(tab?.client_staff) ? tab.client_staff : [];

                return rows
                    .map((row, r) => {
                        const staffNo = normalize(row?.StaffDetailNo);
                        const companyCD = normalize(row?.CompanyCD ?? tab?.CompanyCD);
                        const clientCD = normalize(row?.ClientCD ?? tab?.ClientCD);
                        const branchCD = normalize(row?.BranchCD ?? tab?.BranchCD);

                        const key = staffNo
                            ? `EXIST|${companyCD}|${clientCD}|${branchCD}|${staffNo}`
                            : `NEW|${companyCD}|${clientCD}|${branchCD}|ROW${r}`;

                        const val = JSON.stringify({
                            StartDate: normalizeDate(row?.StartDate),
                            StaffName: normalize(row?.StaffName),
                            FilePath: normalize(row?.FilePath),
                            Remarks: normalize(row?.Remarks)
                        });

                        return `${key}=${val}`;
                    })
                    .sort()
                    .join('||');
            }

            function normalize(v) {
                const s = String(v ?? '').trim();
                return s === '0' ? '' : s;
            }

            function normalizeDate(v) {
                const s = normalize(v);
                const m = s.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
                return m ? `${m[1]}-${m[2].padStart(2, '0')}-${m[3].padStart(2, '0')}` : s;
            }

            function toCircled(n) {
                return ['', '①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩', '⑪', '⑫', '⑬', '⑭', '⑮', '⑯', '⑰', '⑱', '⑲', '⑳'][n] || n;
            }
        },
        buildSubmitPayload(data, winnersByClientBranch) {
            const sites = data.sites ?? [];

            const onsite_tabs = [];
            const office_tabs = [];
            const sales_tabs = [];
            const clientStaffMap = {};

            const normalizeCode = (value) => {
                if (value === null || value === undefined || value === '') return '';
                const num = Number(value);
                return Number.isNaN(num) ? String(value).trim() : String(num);
            };

            const buildClientBranchKey = (clientCD, branchCD) => {
                return `${normalizeCode(clientCD)}__${normalizeCode(branchCD)}`;
            };

            const hasWinners = winnersByClientBranch && typeof winnersByClientBranch === 'object' && Object.keys(winnersByClientBranch).length > 0;

            sites.forEach((site) => {
                if (site.type == 1) {
                    // ===== onsite_tabs =====
                    const row = { ...site };
                    // OnSiteMTGGr1 array -> OnSiteMTGCHK1, OnSiteMTGCHK2
                    if (Array.isArray(row.OnSiteMTGGr1)) {
                        for (let i = 1; i <= 2; i++) {
                            row[`OnSiteMTGCHK${i}`] = row.OnSiteMTGGr1.includes(String(i)) ? 1 : 0;
                        }
                    }
                    // OnSiteMTGGr2 array -> OnSiteMTGCHK4, OnSiteMTGCHK5
                    if (Array.isArray(row.OnSiteMTGGr2)) {
                        for (let i = 4; i <= 5; i++) {
                            row[`OnSiteMTGCHK${i}`] = row.OnSiteMTGGr2.includes(String(i)) ? 1 : 0;
                        }
                    }
                    // OnSiteClient array -> ClientCHK1, ClientCHK2
                    if (Array.isArray(row.OnSiteClient)) {
                        for (let i = 1; i <= 2; i++) {
                            row[`ClientCHK${i}`] = row.OnSiteClient.includes(String(i)) ? 1 : 0;
                        }
                    }

                    delete row.OnSiteMTGGr1;
                    delete row.OnSiteMTGGr2;
                    delete row.OnSiteClient;

                    onsite_tabs.push(row);
                    return;
                }

                if (site.type == 2) {
                    office_tabs.push({ ...site });
                    return;
                }

                if (site.type == 3) {
                    const clientKey = normalizeCode(site.ClientCD);
                    const branchKey = normalizeCode(site.BranchCD);
                    const clientBranchKey = buildClientBranchKey(clientKey, branchKey);
                    const winner = hasWinners ? winnersByClientBranch?.[clientBranchKey] : null;

                    // build sales_tabs
                    const row = { ...site };

                    if (Array.isArray(row.SalesNoteCheck)) {
                        for (let i = 1; i <= 8; i++) {
                            row[`SalesNoteCHK${i}`] = row.SalesNoteCheck.includes(String(i)) ? 1 : 0;
                        }
                    }

                    row.FileKey = row.File instanceof File ? this.getSalesTabFileKey(site) : '';

                    delete row.File;
                    delete row.SalesNoteCheck;
                    delete row.client_staff;
                    delete row.past_sales_records;
                    delete row.paginationData;

                    sales_tabs.push(row);

                    if (!clientKey || !branchKey) return;

                    // build client_staff: 1 bộ / 1 cặp ClientCD && BranchCD
                    if (winner) {
                        if (!clientStaffMap[clientBranchKey]) {
                            clientStaffMap[clientBranchKey] = (winner.client_staff ?? []).map((s, idx) => {
                                const staff = { ...s };

                                staff.FileKey = staff.File instanceof File ? this.getSalesStaffFileKey(winner, idx) : '';

                                delete staff.File;

                                return {
                                    ...staff,
                                    CompanyCD: winner.CompanyCD ?? site.CompanyCD,
                                    MDCD: winner.MDCD ?? site.MDCD,
                                    BranchCD: normalizeCode(staff.BranchCD ?? winner.BranchCD ?? branchKey),
                                    ClientCD: normalizeCode(staff.ClientCD ?? winner.ClientCD ?? clientKey)
                                };
                            });
                        }
                        return;
                    }

                    // client không có trong winnersByClient => tab duy nhất => lấy luôn site.client_staff
                    if (!clientStaffMap[clientBranchKey]) {
                        clientStaffMap[clientBranchKey] = (site.client_staff ?? []).map((s, idx) => {
                            const staff = { ...s };

                            staff.FileKey = staff.File instanceof File ? this.getSalesStaffFileKey(site, idx) : '';

                            delete staff.File;

                            return {
                                ...staff,
                                CompanyCD: site.CompanyCD,
                                MDCD: site.MDCD,
                                BranchCD: normalizeCode(staff.BranchCD ?? site.BranchCD ?? branchKey),
                                ClientCD: normalizeCode(staff.ClientCD ?? site.ClientCD ?? clientKey)
                            };
                        });
                    }
                }
            });

            const client_staff = Object.values(clientStaffMap).flat();

            return {
                general: data.general ?? {},
                time_schedule: data.time_schedule ?? [],
                onsite_tabs,
                office_tabs,
                sales_tabs,
                client_staff
            };
        },

        appendSubmitFiles(formData, data, winnersByClientBranch) {
            const sites = data?.sites ?? [];
            const appendedClientBranchSet = new Set();

            const normalizeCode = (value) => {
                if (value === null || value === undefined || value === '') return '';
                const num = Number(value);
                return Number.isNaN(num) ? String(value).trim() : String(num);
            };

            const buildClientBranchKey = (clientCD, branchCD) => {
                return `${normalizeCode(clientCD)}__${normalizeCode(branchCD)}`;
            };

            // 1) file của sales_tab: append tất cả
            sites
                .filter((site) => site.type == 3)
                .forEach((site) => {
                    if (site.File instanceof File) {
                        formData.append(this.getSalesTabFileKey(site), site.File);
                    }
                });

            // 2) file của client_staff: chỉ 1 bộ / 1 ClientCD + BranchCD
            sites
                .filter((site) => site.type == 3)
                .forEach((site) => {
                    const clientBranchKey = buildClientBranchKey(site.ClientCD, site.BranchCD);
                    if (!clientBranchKey || appendedClientBranchSet.has(clientBranchKey)) return;

                    const winner = winnersByClientBranch?.[clientBranchKey];

                    if (winner) {
                        (winner.client_staff ?? []).forEach((staff, idx) => {
                            if (staff.File instanceof File) {
                                formData.append(this.getSalesStaffFileKey(staff, idx), staff.File);
                            }
                        });

                        appendedClientBranchSet.add(clientBranchKey);
                        return;
                    }

                    // client không có trong winnersByClient => tab duy nhất => lấy site.client_staff
                    (site.client_staff ?? []).forEach((staff, idx) => {
                        if (staff.File instanceof File) {
                            formData.append(this.getSalesStaffFileKey(staff, idx), staff.File);
                        }
                    });

                    appendedClientBranchSet.add(clientBranchKey);
                });
        },
        getSalesTabFileToken(site) {
            if (site?.TabNo) return `TAB${site.TabNo}`;
            return `TMP${site.id}`;
        },
        getSalesTabFileKey(site) {
            return `SalesTabFile_${this.getSalesTabFileToken(site)}`;
        },
        getSalesStaffFileKey(site, idx) {
            return `SalesStaffFile_${this.getSalesTabFileToken(site)}_${idx}`;
        },
        validate() {
            const errors = [];
            const general = this.data?.general ?? {};
            const sites = this.data?.sites ?? [];

            const addError = (name, message = '') => {
                errors.push({ name, message });
            };

            ['CompanyCD', 'WorkDate', 'MDCD', 'OfficeCD'].forEach((field) => {
                if (!general[field]) addError(field);
            });
            const errorTab = [];

            sites.forEach((site) => {
                if (site.type == 3) {
                    if (!site.ClientCD) {
                        addError('ClientCD' + site.id);
                        errorTab.push(Number(site.id) - 1);
                    }

                    if (!site.BranchCD) {
                        addError('BranchCD' + site.id);
                        errorTab.push(Number(site.id) - 1);
                    }
                }
            });

            this.errors = errors;
            this.activeIndex = errorTab[0] ?? 0;

            if (errors.length) {
                this.$nextTick(() => {
                    document.getElementById(errors[0].name)?.focus();
                });
                return false;
            }

            return true;
        },
        hasValidItems(arr) {
            return Array.isArray(arr) && arr.length > 0;
        },

        calculateWorkType(data) {
            let workType = 0;

            if (this.hasValidItems(data.onsite_tabs)) workType += 1;
            if (this.hasValidItems(data.office_tabs)) workType += 2;
            if (this.hasValidItems(data.sales_tabs)) workType += 4;

            return workType;
        },
        submit() {
            this.errors = [];
            const isValid = this.validate();

            if (!isValid) return;

            const salesTabs = this.data.sites.filter((site) => site.type == 3);
            const { hasDiff, messages: cautionMessages, winnersByClientBranch } = this.buildSalesClientStaffCautions(salesTabs);

            const payload = this.buildSubmitPayload(this.data, winnersByClientBranch);
            this.data.general.WorkType = this.calculateWorkType(payload);

            console.log('payload', payload);
            const doSave = () => {
                const formData = new FormData();
                formData.append('data', JSON.stringify(payload));
                formData.append('CompanyCD', this.data.general.CompanyCD);
                this.appendSubmitFiles(formData, this.data, winnersByClientBranch);

                this.saveData({
                    body: formData,
                    callback: () => {
                        this.showModalMessage({
                            type: MSG_TYPE.SUCCESS,
                            title: MSG_TITLE.S001,
                            content: messages.S001,
                            cancelText: MSG_BUTTON.cancelText,
                            okText: MSG_BUTTON.okText,
                            callback: () => this.$emit('hideDetailTab')
                        });
                    },
                    onErrorValidate: this.showSubmitError,
                    onError: this.showSubmitError
                });
            };

            const askConfirm = () => {
                this.showModalMessage({
                    type: MSG_TYPE.CONFIRM,
                    title: MSG_TITLE.C003,
                    content: '登録してもよろしいですか？',
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: doSave
                });
            };

            if (!hasDiff) return askConfirm();

            this.showModalMessage({
                type: MSG_TYPE.ERROR,
                title: MSG_TITLE.E001,
                content: cautionMessages.join('\n\n'),
                callback: askConfirm
            });
        },

        showSubmitError(message) {
            this.showModalMessage({
                type: MSG_TYPE.ERROR,
                title: MSG_TITLE.E001,
                content: message,
                cancelText: MSG_BUTTON.cancelText,
                okText: MSG_BUTTON.okText
            });
        },
        deleteItemTable(index_no) {
            if (this.data.time_schedule.length == 1) return;
            if (this.data.time_schedule[index_no]['WorkTime'] == '' && this.data.time_schedule[index_no]['WorkDetail'] == '') {
                this.data.time_schedule.splice(index_no, 1);
            } else {
                this.showModalMessage({
                    type: MSG_TYPE.CONFIRM,
                    title: MSG_TITLE.C003,
                    content: messages.C003,
                    cancelText: 'いいえ',
                    okText: 'はい',
                    callback: (ok) => {
                        if (ok) {
                            if (this.data.time_schedule.length > 1) {
                                this.data.time_schedule.splice(index_no, 1);
                            }
                        }
                    }
                });
            }
        },
        changeType() {
            this.changeTypeState(this.data.type);
        },
        removePlace(index) {
            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C003,
                content: messages.C003,
                cancelText: 'いいえ',
                okText: 'はい',
                callback: (ok) => {
                    if (ok) {
                        // Lưu lại type của tab bị xóa để cập nhật index_type
                        let deletedType = this.data.sites[index].type;

                        if (this.activeIndex === index) {
                            this.activeIndex = index > 0 ? index - 1 : 0;
                        } else if (this.activeIndex > index) {
                            this.activeIndex--;
                        }

                        this.data.sites.splice(index, 1);

                        // Đánh lại ID theo thứ tự từ 1 đến n
                        this.data.sites.forEach((place, idx) => {
                            place.id = idx;
                        });

                        // Cập nhật lại index_type của các tab cùng type với tab bị xóa
                        let typeCount = 0;
                        this.data.sites.forEach((place) => {
                            if (place.type == deletedType) {
                                typeCount++;
                                place.index_type = typeCount;
                            }
                        });

                        // Cập nhật nextId để phù hợp với số lượng phần tử hiện tại
                        this.nextId = this.data.sites.length;

                        if (this.activeIndex >= this.data.sites.length) {
                            this.activeIndex = this.data.sites.length - 1;
                        }
                    }
                }
            });
        },
        openDetail() {
            this.$emit('open');
        },
        focusWorkDate() {
            document.getElementById('WorkDate')?.focus();
        },
        validateWorkingDate() {
            if (!this.data.general.WorkDate) {
                this.removeError('WorkDate');
                return;
            }

            // Parse WorkDate (format: YYYY/MM/DD or YYYYMMDD)
            let workingDateStr = this.data.general.WorkDate;
            if (workingDateStr.length === 8 && !workingDateStr.includes('/')) {
                // Format YYYYMMDD to YYYY/MM/DD
                workingDateStr = `${workingDateStr.substring(0, 4)}/${workingDateStr.substring(4, 6)}/${workingDateStr.substring(6, 8)}`;
            }

            const workingDate = new Date(workingDateStr);
            if (isNaN(workingDate.getTime())) {
                this.removeError('WorkDate');
                return;
            }

            // Get current date and set to start of day
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            // Calculate 2 days ago
            const threeDaysAgo = new Date(today);
            threeDaysAgo.setDate(today.getDate() - 2);

            // Set working date to start of day for comparison
            workingDate.setHours(0, 0, 0, 0);

            if (workingDate < threeDaysAgo) {
                // Check if error already exists to avoid duplicates
                const existingError = this.errors.find((e) => e.name === 'WorkDate');
                if (!existingError) {
                    this.addError({
                        name: 'WorkDate',
                        message: '⚠登録・修正は2日前までのものしか出来ません'
                    });
                }
            } else {
                this.removeError('WorkDate');
            }
        },
        addError(errorObj) {
            const existingIndex = this.errors.findIndex((e) => e.name === errorObj.name);
            if (existingIndex >= 0) {
                this.errors[existingIndex] = errorObj;
            } else {
                this.errors.push(errorObj);
            }
        },
        removeError(fieldName) {
            this.errors = this.errors.filter((e) => e.name !== fieldName);
        },
        getMDName(data) {
            this.data.general.MDName = data;
            this.data.general.OfficeCD = '';
            this.data.general.OfficeName = '';
        },
        referMDCD(index, value, init = false) {
            if (value) {
                this.searchAreaInfo({
                    company_cd: this.data.general.CompanyCD ?? this.user?.company_cd ?? 0,
                    department_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.general.MDCD = result.department_cd;
                            this.data.general.MDName = result.department_name;
                            if (!init) {
                                this.data.general.OfficeCD = '';
                                this.data.general.OfficeName = '';
                            }
                        } else {
                            this.data.general.MDCD = '';
                            this.data.general.MDName = '';
                            if (!init) {
                                this.data.general.OfficeCD = '';
                                this.data.general.OfficeName = '';
                            }
                        }
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                this.data.general.MDCD = '';
                this.data.general.MDName = '';
                this.data.general.OfficeCD = '';
                this.data.general.OfficeName = '';
            }
        },
        getOfficeName(data) {
            this.data.general.OfficeName = data;
        },
        referOffice(index, value) {
            if (value) {
                this.searchOfficeInfo({
                    company_cd: this.data.general.CompanyCD ?? 0,
                    department_cd: this.data.general.MDCD ?? 0,
                    office_cd: value,
                    mode: 1,
                    callback: (response) => {
                        const result = response?.Data?.data?.[0];
                        if (result) {
                            this.data.general.OfficeCD = result.office_cd;
                            this.data.general.OfficeName = result.office_name;
                        } else {
                            this.data.general.OfficeCD = '';
                            this.data.general.OfficeName = '';
                        }
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                this.data.general.OfficeCD = '';
                this.data.general.OfficeName = '';
            }
        },
        getBranchName(data, place) {
            place.BranchName = data;
        },
        referBranchCD(value, place) {
            if (!value) {
                place.BranchCD = '';
                place.BranchName = '';
                return;
            }
            this.searchMst002Info({
                company_cd: this.data.general.CompanyCD ?? this.user?.company_cd ?? '',
                customer_cd: place.ClientCD ?? 0,
                mdcd: this.data.general.MDCD ?? 0,
                location_cd: value || 0,
                pageNo: 1,
                pageSize: 1,
                mode: 1,
                callback: (response) => {
                    const result = response?.Data?.data?.[0];
                    if (result) {
                        place.BranchCD = result.location_cd;
                        place.BranchName = result.location_name;
                    } else {
                        place.BranchCD = '';
                        place.BranchName = '';
                    }
                }
            });
        },
        getClientName(data, place) {
            place.ClientName = data;
            place.BranchCD = '';
            place.BranchName = '';
        },
        referClientCD(value, place) {
            if (!value) {
                place.ClientCD = '';
                place.ClientName = '';
                place.BranchCD = '';
                place.BranchName = '';
                return;
            }
            this.searchMst001Info({
                company_cd: place.CompanyCD ?? '',
                customer_cd: value || 0,
                pageNo: 1,
                pageSize: 1,
                callback: (response) => {
                    const result = response?.Data?.data?.[0];
                    if (result) {
                        place.ClientCD = result.customer_cd;
                        place.ClientName = result.customer_name;
                    } else {
                        place.ClientCD = '';
                        place.ClientName = '';
                    }
                    place.BranchCD = '';
                    place.BranchName = '';
                }
            });
        },
        getCompanyName(data) {
            this.data.general.CompanyName = data;
        },
        referCompanyInfo(index, value) {
            if (!value) {
                this.data.general.CompanyCD = '';
                this.data.general.CompanyName = '';
                return;
            }
            this.searchSystemInfo({
                company_cd: value,
                mode: 1,
                callback: (response) => {
                    const result = response?.Data?.data?.[0];
                    if (result) {
                        this.data.general.CompanyCD = result.company_cd;
                        this.data.general.CompanyName = result.company_name;
                    } else {
                        this.data.general.CompanyCD = '';
                        this.data.general.CompanyName = '';
                    }
                }
            });
        }
    }
};
export default APP_WorkReport002;
</script>
